import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import BASE_URL from "../config";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
const MarksEditPage = () => {
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [studentsMap, setStudentsMap] = useState({});
  const [marksData, setMarksData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  useEffect(() => {
    axios.get(`${BASE_URL}/api/exams`)
      .then((res) => setExams(res.data))
      .catch(console.error);
  }, []);
  useEffect(() => {
    if (!selectedExam) return;
    setLoading(true);
    setSearchTerm("");
    setCurrentPage(1);
    const { ExamID, CourseID, ClassID,AcademicYearID } = selectedExam;
    Promise.all([
      //axios.get(`${BASE_URL}/api/exams/${ExamID}/subjects`),
      axios.get(`${BASE_URL}/api/exams/${ExamID}/subjects`, {
          params: { courseId: CourseID, classId: ClassID, yearId: AcademicYearID }
        }),
      axios.get(`${BASE_URL}/api/students`, { params: { courseId: CourseID, classId: ClassID } }),
      axios.get(`${BASE_URL}/api/exam-marks`, { params: { examId: ExamID } })
    ])
    .then(([subjRes, studRes, marksRes]) => {
      setSubjects(subjRes.data);
      const studList = Array.isArray(studRes.data.students) ? studRes.data.students : [];
      const map = {};
      studList.forEach((s) => (map[s.StudentID] = s.StudentName));
      setStudentsMap(map);
      setMarksData(
        marksRes.data.map((m) => ({ ...m, EditedMarks: m.MarksObtained }))
      );
    })
    .catch(console.error)
    .finally(() => setLoading(false));
  }, [selectedExam]);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);
  const handleEditChange = (markId, value) => {
    setMarksData((prev) =>
      prev.map((item) =>
        item.MarkID === markId ? { ...item, EditedMarks: value } : item
      )
    );
  };
  const saveMark = (item) => {
    const subj = subjects.find((s) => s.SubjectID === item.SubjectID);
    let marks = item.EditedMarks;
  // Normalize Ab to -1
  if (typeof marks === "string" && marks.trim().toLowerCase() === "ab") {
    marks = -1;
  }
  // Validate numeric marks
  if (marks !== -1 && !isNaN(marks)) {
    const numeric = parseInt(marks, 10);
    if (numeric > subj.TotalMarks) {
      alert(`Marks should be less than or equal to ${subj.TotalMarks}`);
      return; // 🚫 stop here
    }
    marks = numeric; // safe to use as number
  }
    setSavingId(item.MarkID);
     //let marks = item.EditedMarks;
    axios.put(`${BASE_URL}/api/exam-marks/${item.MarkID}`, {
      //MarksObtained: item.EditedMarks,
      MarksObtained: marks,
    })
    .then(() => {
      setMarksData((prev) =>
        prev.map((i) =>
          i.MarkID === item.MarkID 
      //? { ...i, MarksObtained: item.EditedMarks } 
       ? { ...i, MarksObtained: marks, EditedMarks: marks }
      : i
        )
      );
    })
    .catch(console.error)
    .finally(() => setSavingId(null));
  };
  const groupedByStudent = useMemo(() => {
    const groups = {};
    marksData.forEach((m) => {
      if (!groups[m.StudentID]) groups[m.StudentID] = [];
      groups[m.StudentID].push(m);
    });
    return Object.entries(groups).map(([studentId, items]) => ({
      studentId,
      studentName: studentsMap[studentId] || studentId,
      marks: items,
    }));
  }, [marksData, studentsMap]);
  const filteredGroups = useMemo(() =>
    groupedByStudent.filter(({ studentName }) =>
      studentName.toLowerCase().includes(searchTerm.toLowerCase())
    ), [groupedByStudent, searchTerm]);
  const totalPages = Math.ceil(filteredGroups.length / itemsPerPage) || 1;
  const paginatedGroups = filteredGroups.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };
  const insertHeader = (doc) => {
    doc.setFontSize(18);
    doc.text("SMC Jain School-Shahapur", 105, 15, { align: "center" });
    doc.setFontSize(10);
    doc.text("Phone: +91 9620319410,7760033330,08488 295048 | Email: chairmansmcjskl@gmail.com", 105, 22, { align: "center" });
  };
  const insertFooter = (doc) => {
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.text(`Page ${i} of ${pageCount}`, 200, 290, { align: "right" });
      doc.text("Principal Signature ____________________", 14, 290);
    }
  };
  const handleDownloadPDF = () => {
    if (!selectedExam) {
      alert("Please select an exam first!");
      return;
    }
    const doc = new jsPDF();
    insertHeader(doc);
    const examTitle = selectedExam.ExamName;
    let currentY = 40;
    groupedByStudent.forEach(({ studentName, marks }) => {
      if (currentY > 270) {
        doc.addPage();
        insertHeader(doc);
        currentY = 40;
      }
      doc.setFontSize(12);
      doc.text(`Student: ${studentName}`, 14, currentY);
      currentY += 6;
      const studentTable = marks.map((mark) => {
        const subject = subjects.find((s) => s.SubjectID === mark.SubjectID);
        return [
          subject?.SubjectName || mark.SubjectID,
          mark.EditedMarks ?? mark.MarksObtained,
          subject?.TotalMarks ?? "-"
        ];
      });
      autoTable(doc, {
        startY: currentY,
        head: [["Subject", "Marks Obtained", "Max Marks"]],
        body: studentTable,
        theme: "grid",
        styles: { fontSize: 10, halign: "center" },
        headStyles: { fillColor: [25, 118, 210] },
        margin: { left: 14, right: 14 },
        didDrawPage: (data) => {
          currentY = data.cursor.y + 10;
        },
      });
    });
    insertFooter(doc);
    doc.save(`${examTitle}_MarksList.pdf`);
  };
  const handleDownloadSingleStudentPDF = (studentName, marks, examName, className,courseName,yearName) => {
    const doc = new jsPDF();
    insertHeader(doc);
    //doc.setFontSize(14);
    doc.setFontSize(12);
    //doc.text(`Student: ${studentName}`, 105, 40, { align: "center" });
     // Show Student, Exam and Class
     // First line: Student, Exam, Course
     // First line: Student, Exam, Course
  doc.text(`Student: ${studentName}`, 14, 40);     // left
  doc.text(`Exam: ${examName}`, 105, 40, { align: "center" }); // center
  doc.text(`Course: ${courseName}`, 200, 40, { align: "right" }); // right

  // Second line: Class, Year
  doc.text(`Class: ${className}`, 14, 48);
  doc.text(`Year: ${yearName}`, 200, 48, { align: "right" });
  /* doc.text(`Student: ${studentName}`, 14, 40);     // left
  doc.text(`Class: ${className}`, 105, 40, { align: "center" }); // center
  doc.text(`Exam: ${examName}`, 200, 40, { align: "right" }); // right

  // Second line: Class, Year
  doc.text(`Course: ${courseName}`, 14, 48);
  doc.text(`Year: ${yearName}`, 200, 48, { align: "right" }); */
     /* doc.text(
  `Student: ${studentName}\nExam: ${examName}\nClass: ${className}\nCourse: ${courseName}\nYear: ${yearName}`,
  105,
  40,
  { align: "center" }
); */
 /*  doc.text(
    `Student: ${studentName}\nExam: ${examName}\nClass: ${className}`,
    105,
    40,
    { align: "center" }
  ); */
    const studentTable = marks.map((mark) => {
      const subject = subjects.find((s) => s.SubjectID === mark.SubjectID);
      return [
        subject?.SubjectName || mark.SubjectID,
        //mark.EditedMarks ?? mark.MarksObtained,
        mark.EditedMarks === -1 ? "Ab" : (mark.EditedMarks ?? mark.MarksObtained),
        subject?.TotalMarks ?? "-"
      ];
    });
    autoTable(doc, {
      startY: 58,
      head: [["Subject", "Marks Obtained", "Max Marks"]],
      body: studentTable,
      theme: "grid",
      styles: { fontSize: 10, halign: "center" },
      headStyles: { fillColor: [25, 118, 210] },
      margin: { left: 14, right: 14 },
    });
    insertFooter(doc);
    doc.save(`${studentName}_Marks.pdf`);
  };
  return (
    <div className="container mt-4">
      <h3>Edit Marks</h3>
      <div className="mb-3">
        <label className="form-label">Select Exam</label>
        <select
          className="form-select"
          //value={selectedExam?.ExamID || ""}
           value={
      selectedExam
        ? `${selectedExam.ExamID}_${selectedExam.CourseID}_${selectedExam.ClassID}_${selectedExam.AcademicYearID}`
        : ""
    }
         /*  onChange={(e) => {
            const ex = exams.find((x) => x.ExamID === +e.target.value);
            setSelectedExam(ex || null);
          }} */
         onChange={e => {
      const ex = exams.find(
        x =>
          `${x.ExamID}_${x.CourseID}_${x.ClassID}_${x.AcademicYearID}` ===
          e.target.value
      );
      setSelectedExam(ex || null);
    }}
        >
          <option value="">-- Choose an exam --</option>
          {exams.map((ex) => (
           /*  <option key={ex.ExamID} value={ex.ExamID}>
              {ex.ExamName}
            </option> */
                  <option
        key={`${ex.ExamID}_${ex.CourseID}_${ex.ClassID}_${ex.AcademicYearID}`}
        value={`${ex.ExamID}_${ex.CourseID}_${ex.ClassID}_${ex.AcademicYearID}`}
      >
        {ex.DisplayName}
      </option>
          ))}
        </select>
      </div>
      {selectedExam && (
        <div className="mb-3">
          <button className="btn btn-success" onClick={handleDownloadPDF}>
            Download Full Exam Marks
          </button>
        </div>
      )}
      {loading && <p>Loading marks and metadata…</p>}
      {selectedExam && !loading && (
        <>
          <div className="mb-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search by student name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {paginatedGroups.map(({ studentId, studentName, marks }) => (
            <div key={studentId} className="mb-5">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="mb-0">{studentName}</h5>
                <button
                  className="btn btn-sm btn-outline-success"
                  onClick={() => handleDownloadSingleStudentPDF(studentName, marks, selectedExam.ExamName, selectedExam.ClassName,
  selectedExam.CourseName,
  selectedExam.AcademicYearName)}
                >
                  Download Marks
                </button>
              </div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Subject</th>
                    <th>Marks Obtained</th>
                    <th>Max Marks</th>
                    <th>Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {marks.map((item) => {
                    const subj = subjects.find((s) => s.SubjectID === item.SubjectID);
                    return (
                      <tr key={item.MarkID}>
                        <td>{subj?.SubjectName || item.SubjectID}</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            style={{ width: "100px" }}
                            //value={item.EditedMarks}
                             value={item.EditedMarks === -1 ? "Ab" : item.EditedMarks ?? ""}
                            min={0}
                            max={subj?.TotalMarks || ""}
                            onChange={(e) =>
                              handleEditChange(item.MarkID, e.target.value)
                            }
                          />
                        </td>
                        <td>{subj?.TotalMarks ?? ""}</td>
                        <td>{new Date(item.CreatedDate).toLocaleDateString()}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => saveMark(item)}
                            disabled={savingId === item.MarkID}
                          >
                            {savingId === item.MarkID ? "Saving…" : "Save"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ))}
        </>
      )}
    </div>
  );
};
export default MarksEditPage;
